import CustomButtton from "../Button/CustomButtton";
import { cards, group, label, play } from "../../images/general";
import React from "react";
import { constants } from "../../utils/constants";
import { Link } from "gatsby";

const StoryTabOne = ({showVideo} : {showVideo: () => void}) => {
  return (
      <div className="transition-opacity ease-in duration-700">
        <div className="container mx-auto flex sm:flex-row flex-col-reverse items-center">
          <div className="lg:w-[67.5%] mt-0 sm:-mt-20">
            <h2 className="sm:text-7xl text-[28px] font-cinzel text-white font-bold sm:leading-[64px] leading-7 sm:mx-0 mx-auto sm:text-left text-center sm:w-full w-3/5">
              Join <span className="text-[#E7D4C5]">millions</span> of players
            </h2>
            <p className="sm:font-cinzel font-normal sm:text-2xl text-base sm:text-left text-center sm:leading-10 leading-8 text-white py-7">
            Build, explore and conquer land, fortune and glory in a blockchain powered historical world, filled with exciting opportunities to play and own!
            </p>
            <div className="sm:w-max w-9/12 sm:mx-0 mx-auto sm:mb-3 md:mb-0 mb-32">
              <Link to={constants.app_routes.login}>
              <CustomButtton text="Play Now" icon2={group}/>
              </Link>
            </div>
          </div>

          <div className="lg:w-full mt-6 lg:mt-0 relative hover:scale-110 transition duration-300 cursor-pointer">
            <img src={cards} className="sm:w-full w-[348.94px] animate-pulse" alt="cards"/>
            <div className="">
            <img src={play} alt="play" className="absolute top-0 bottom-0 right-0 left-0 m-auto sm:w-max w-[111px] cursor-pointer" onClick={showVideo}/>
            <img src={label} alt="label" className="absolute sm:top-36 top-[4.8rem] bottom-0 right-0 left-0 m-auto sm:w-max w-[158.25px]" />
            </div>
          </div>
        </div>
      </div>
  );
};

export default StoryTabOne;
